module.exports = __webpack_public_path__ + "img/Waze.d15416f0.png";